import { useEffect } from 'react';
import { BASE_PATH } from 'constants/index';
import { ONB_BANK_DEPOSIT_OPEN } from 'constants/onboardingTypes';
import { ROBO, GBI, TRADITIONAL } from 'constants/userProfile';
import { history } from 'routes/history';
import { getIsAuthorized } from 'utilities/jointHolders/holderTypes';

export const useStepSelectionOnMount = ({ userProfile, immStepsState, stepsActions }) => {
    const {
        iban,
        investmentType,
        isJointHolder,
        isJointHolderNoClient,
        jointHolderData,
        jointHolderType,
        onboardingType,
        withConfigCard,
    } = userProfile;

    useEffect(() => {
        const wizardSelected = immStepsState.get('wizardSelected');
        if (typeof iban === 'undefined') {
            history.push(BASE_PATH);
        }
        if (
            investmentType === TRADITIONAL &&
            onboardingType === ONB_BANK_DEPOSIT_OPEN &&
            !isJointHolder &&
            wizardSelected !== 'depositSteps'
        ) {
            stepsActions.selectDepositSteps();
        }

        if (getIsAuthorized(jointHolderType) && isJointHolderNoClient && wizardSelected !== 'authorizedSteps') {
            stepsActions.selectAuthorizedSteps();
        }

        if (jointHolderData && !isJointHolderNoClient && wizardSelected !== 'clientSteps') {
            stepsActions.selectClientSteps();
            stepsActions.changeMinFinalizeStep({ index: 0 });
        }

        if (withConfigCard && wizardSelected !== 'configCardSteps') {
            stepsActions.selectConfigCardSteps();
        }

        if (investmentType === ROBO && wizardSelected !== 'roboSteps') {
            stepsActions.selectRoboSteps();
            stepsActions.changeMinFinalizeStep({ index: 3 });
        }

        if (investmentType === GBI && wizardSelected !== 'gbiSteps') {
            stepsActions.selectGbiSteps();
            stepsActions.changeMinFinalizeStep({ index: 4 });
        }
    }, []);
};
